export default function PickupIcon() {
  return <i className="fa-solid fa-bag-shopping"></i>
}